import React from 'react';
import axios from "axios";

class ModuleDeleteButton extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            name: this.props.name,
            saveToDelete: false
        };
        this.componentDidMount = this.componentDidMount.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    componentDidMount() {
        const path = __API__ + `/api/ui/module/savetodelete/${this.props.name}`;
        axios.put(path)
        .then(response => {
            return response.data;
        })
        .then(data => {
            this.setState({
                saveToDelete: data
            })
        })
        .catch(error => {
            console.log(error);
        });
    }

    handleDelete() {
        if (window.confirm("Sind Sie sicher, dass Sie das Modul \"" + this.state.name + "\" wirklich löschen wollen?")) {
            this.props.deleteModule(this.props.name);
        }
    }

    render() {
        return (
                <button className="btn btn-danger"
                        disabled={!this.state.saveToDelete}
                        onClick={this.handleDelete}
                        title={"Modul löschen"}>
                    <i className="fa fa-exclamation-triangle"/>&nbsp; Löschen
                </button>
        )
    }
}

export default ModuleDeleteButton;



// WEBPACK FOOTER //
// ./src/admin/components/ModuleDeleteButton.js